<template>
	<span v-if="visible" :class="{ 'text-grey': compProps.grey }">{{ displayedValue }}</span>
</template>

<script setup lang="ts">
import type { InstanceDataobject } from "@lr-notitia/notitia-operator/schemas";
import { computed, PropType } from "vue";
import { useGraphStore } from "../../../store/graph";
import { useSymbolsStore } from "../../../store/symbols";

const graphStore = useGraphStore();
const symbolsStore = useSymbolsStore();

const compProps = defineProps({
	dataobject: {
		type: Object as PropType<InstanceDataobject>,
		required: true,
	},
	grey: {
		type: Boolean,
		default: true,
	},
	conceptCount: {
		type: Number,
		default: 1,
	},
	conceptIndex: {
		type: Number,
		default: 1,
	},
});

const identifierAttribute = computed(() => {
	let identifierTerm = "Notitia_Operator_Identifier";
	return compProps.dataobject.consistsOf
		.map((id) => graphStore.instance.attribute.byId(id))
		.find((attr) => {
			let conceptAttr = graphStore.concept.attribute.byId(attr?.concept || "");
			let conceptAttrTerm = symbolsStore.term({
				id: conceptAttr?.refersTo || "",
				terminology: conceptAttr?.terminology,
				lang: "en",
			});
			return conceptAttrTerm === identifierTerm;
		});
});
const attributeValue = computed(() => {
	return (
		String(identifierAttribute.value?.value)
			// replace all "unknown" with ""
			?.replaceAll("unknown", "")
			// replace all "undefined" with ""
			?.replaceAll("undefined", "")
			?.trim()
	);
});
const hasAttributeIdentifier = computed(() => {
	return (
		identifierAttribute.value !== undefined &&
		identifierAttribute.value.value !== undefined &&
		identifierAttribute.value.value !== null &&
		identifierAttribute.value.value !== "" &&
		attributeValue.value !== ""
	);
});

const shouldShowCount = computed(() => {
	return !hasAttributeIdentifier.value && compProps.conceptCount > 1;
});

const displayedValue = computed(() => {
	if (hasAttributeIdentifier.value) return attributeValue.value;
	if (shouldShowCount.value) return compProps.conceptIndex.toString();
	return "";
});

const visible = computed(() => {
	return hasAttributeIdentifier.value || shouldShowCount.value;
});
</script>
